import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { requestLoginLink, verifyToken } from '../adminApi.js'
import { useAdminAuth } from '../adminAuth.jsx'

export default function AdminLoginPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { login } = useAdminAuth()
  const token = searchParams.get('token')

  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')
  const [verifying, setVerifying] = useState(!!token)
  // The token is one-time-use server-side - StrictMode's dev-mode double
  // effect-invocation would otherwise burn it on the first call and 401 on
  // the second. Guard so verifyToken only ever fires once per token.
  const verifiedRef = useRef(false)

  useEffect(() => {
    if (!token || verifiedRef.current) return
    verifiedRef.current = true
    verifyToken(token)
      .then((data) => {
        login(data)
        navigate('/admin', { replace: true })
      })
      .catch((e) => {
        setError(e.message)
        setVerifying(false)
      })
  }, [token, login, navigate])

  const submit = async (e) => {
    e.preventDefault()
    setError('')
    try {
      await requestLoginLink(email)
      setSent(true)
    } catch (e) {
      setError(e.message)
    }
  }

  if (verifying) {
    return <div className="empty-state">Verifying your login link…</div>
  }

  return (
    <div className="admin-login">
      <div className="icon">🔐</div>
      <h2>Admin sign-in</h2>
      <p>Enter the email registered for this event. We'll send a one-time link — no password to remember.</p>
      <form onSubmit={submit}>
        <div className="field">
          <label htmlFor="adminEmail">Email address</label>
          <input
            id="adminEmail"
            type="email"
            placeholder="secretary@nhca.co.uk"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button className="btn-primary" type="submit">Send magic link</button>
      </form>
      {sent && (
        <div className="magic-sent">Link sent — check your inbox. It's valid for 24 hours and can only be used once.</div>
      )}
      {error && (
        <div className="magic-sent" style={{ color: 'var(--red)', background: 'color-mix(in srgb, var(--red) 14%, transparent)' }}>
          {error}
        </div>
      )}
    </div>
  )
}
